import { Card, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CustomTooltip from "./CustomTooltip";

interface JobStatisticsTableProps {
    data: any;
}

const JobStatisticsTable = ({ data }: JobStatisticsTableProps) => {
    const { t } = useTranslation();

    if (!data) return null;

    const tableData = [
        {
            description: t("dashboard.totalJobs"),
            value: data.totalJobs || "0",
            tooltip: t("dashboard.tooltips.totalJobs")
        },
        {
            description: t("dashboard.activeJobs"),
            value: data.currentActiveJobs || "0",
            tooltip: t("dashboard.tooltips.activeJobs")
        },
        {
            description: t("dashboard.allocatedJobs") + " (%)",
            value: data.allocatedJobsPercent ? `${data.allocatedJobsPercent.toFixed(1)}%` : "0%",
            tooltip: t("dashboard.tooltips.allocatedJobs")
        },
        {
            description: t("dashboard.unallocatedJobs") + " (%)",
            value: data.unallocatedJobsPercent ? `${data.unallocatedJobsPercent.toFixed(1)}%` : "0%",
            tooltip: t("dashboard.tooltips.unallocatedJobs")
        }
    ];

    return (
        <Col md={6} className="my-3">
            <Card className="table-card h-100 ">
                <Card.Header>
                    <h5>{t("dashboard.jobStatistics")}</h5>
                </Card.Header>
                <Card.Body className="py-3 px-0">
                    <div className="table-responsive">
                        <table className="table table-hover table-borderless mb-0">
                            <tbody>
                                {tableData.map((item, key) => (
                                    <tr key={key}>
                                        <td>
                                            <CustomTooltip text={item.tooltip}>
                                                <span className="text-muted">{item.description}</span>
                                            </CustomTooltip>
                                        </td>
                                        <td className="text-end f-w-600">{item.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default JobStatisticsTable;
